import { render } from "./InvoiceDetailPublic.vue?vue&type=template&id=528d1158&ts=true"
import script from "./InvoiceDetailPublic.vue?vue&type=script&lang=ts"
export * from "./InvoiceDetailPublic.vue?vue&type=script&lang=ts"

import "./InvoiceDetailPublic.vue?vue&type=style&index=0&id=528d1158&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__